import { gql } from '@apollo/client';
import { lineItemForRefund, coupledRefundItemsForRefund } from './fetch-refund-line-items';

export const billAndShipTo = gql`
  fragment billAndShipTo on InvoiceBillAndShipTo {
    fullName
    organization
    email
    address {
      address1
      address2
      city
      country
      phone
      postalCode
      state
    }
    taxId
    taxIds {
      id
      label
    }
    taxLabels {
      region
      taxIdLabels {
        description
        displayName
        type
      }
    }
  }
`;

export const partnerRefund = gql`
  ${lineItemForRefund}
  ${coupledRefundItemsForRefund}
  ${billAndShipTo}
  fragment partnerRefund on Refunds {
    id
    arn
    creditNoteNumber
    transactionAccountId
    sourceSystem
    sourceSystemId
    memo
    reason
    reasonCode
    refundId
    chargeId
    rechargeInvoiceId
    status
    type
    createdDate
    orderId
    currency
    total
    totalExTax
    totalTax
    refundItems {
      ...lineItemForRefund
    }
    dstRefundItems {
      ...lineItemForRefund
      metadata {
        type
        parentItemId
      }
    }
    coupledRefundItems(fetchAGPAddon: $fetchAGPAddon) {
      ...coupledRefundItemsForRefund
    }
    billTo {
      ...billAndShipTo
    }
    shipTo {
      ...billAndShipTo
    }
    purchaseOrderNumber
    creditNoteId
  }
`;

export const fetchRefundDetailQueryV2 = gql`
  ${partnerRefund}
  query fetchRefundDetailQueryv2($id: ID!, $fetchAddOns: Boolean = false, $fetchAGPAddon: Boolean = false) {
    refund(id: $id, fetchAddOns: $fetchAddOns, fetchAGPAddon: $fetchAGPAddon) {
      ...partnerRefund
      creationNotes
      isPartner
      creditCardLastFourDigits
      paymentMethod
      currency
    }
  }
`;

export const fetchPartnerRefundDetailsQuery = gql`
  ${partnerRefund}
  query fetchPartnerRefundDetailQuery(
    $id: ID!
    $transactionAccountId: String!
    $fetchAddOns: Boolean = false
    $fetchAGPAddon: Boolean = false
    $fetchPricingPlan: Boolean = false
  ) {
    refund(
      id: $id
      where: { transactionAccountId: $transactionAccountId }
      fetchAddOns: $fetchAddOns
      fetchAGPAddon: $fetchAGPAddon
      fetchPricingPlan: $fetchPricingPlan
    ) {
      ...partnerRefund
      isPartner
      creditCardLastFourDigits
      paymentMethod
    }
  }
`;
